import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    useAdminRussiaPendingTopUps,
    useAdminRussiaConfirmTopUp,
    useAdminRussiaCancelTopUp,
    AdminRussiaPendingPayment,
} from "../api/wallet";
import { useNotification } from "../hooks/useNotification";
import Notification from "../components/ui/Notification";

const AdminTopUpPage: React.FC = () => {
    const { t } = useTranslation("dashboard");
    const { showError, showSuccess, notification, hideNotification } =
        useNotification();

    const [activeTab] = useState<"russia">("russia");

    // Russia exchanger state
    const { data: russiaPendingResponse } = useAdminRussiaPendingTopUps();
    const russiaPayments = russiaPendingResponse?.data?.payments ?? [];
    const adminConfirmRussia = useAdminRussiaConfirmTopUp();
    const adminCancelRussia = useAdminRussiaCancelTopUp();
    const [cancelReason, setCancelReason] = useState<string>("");

    return (
        <>
            <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                        {t("admin_topup.title")}
                    </h1>
                </div>

                {/* Табы */}
                <div className="mb-6" />

                {/* другие вкладки убраны как дубли */}

                {activeTab === "russia" && (
                    <div>
                        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                            Заявки через обменщиков (все)
                        </h2>

                        {russiaPayments.length === 0 ? (
                            <div className="text-center py-8">
                                <div className="text-gray-400 text-4xl mb-4">
                                    💱
                                </div>
                                <p className="text-gray-500 dark:text-gray-400">
                                    Нет заявок в ожидании
                                </p>
                            </div>
                        ) : (
                            <div className="space-y-4">
                                {russiaPayments.map(
                                    (p: AdminRussiaPendingPayment) => (
                                        <div
                                            key={p.id}
                                            className="border border-gray-200 dark:border-gray-700 rounded-lg p-4"
                                        >
                                            <div className="flex justify-between items-start">
                                                <div className="flex-1">
                                                    <h3 className="font-medium text-gray-900 dark:text-white">
                                                        Заявка #{p.id}
                                                    </h3>
                                                    <div className="mt-2 space-y-1 text-sm text-gray-900 dark:text-gray-100">
                                                        <p>
                                                            <span className="font-medium">
                                                                Клиент:
                                                            </span>{" "}
                                                            {p.user_name} (ID{" "}
                                                            {p.user_id})
                                                        </p>
                                                        <p>
                                                            <span className="font-medium">
                                                                Сумма:
                                                            </span>{" "}
                                                            {p.amount_rub} ₽ →{" "}
                                                            {p.amount_usdt} USDT
                                                        </p>
                                                        <p>
                                                            <span className="font-medium">
                                                                Телефон для
                                                                перевода:
                                                            </span>{" "}
                                                            {p.receiver_tel}
                                                        </p>
                                                        <p>
                                                            <span className="font-medium">
                                                                Получатель:
                                                            </span>{" "}
                                                            {p.receiver_name}
                                                        </p>
                                                        <p>
                                                            <span className="font-medium">
                                                                Кошелек BEP20:
                                                            </span>{" "}
                                                            <span className="font-mono">
                                                                {(p as any)
                                                                    .user_bep20 ||
                                                                    "—"}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            <span className="font-medium">
                                                                Кошелек TRC20:
                                                            </span>{" "}
                                                            <span className="font-mono">
                                                                {(p as any)
                                                                    .user_trc20 ||
                                                                    "—"}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            <span className="font-medium">
                                                                Создано:
                                                            </span>{" "}
                                                            {new Date(
                                                                p.created_at
                                                            ).toLocaleString(
                                                                "ru-RU"
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="ml-4 grid gap-2">
                                                    <button
                                                        onClick={() =>
                                                            adminConfirmRussia.mutate(
                                                                p.id,
                                                                {
                                                                    onSuccess: (
                                                                        res: any
                                                                    ) => {
                                                                        showSuccess(
                                                                            res?.message ||
                                                                                "Подтверждено"
                                                                        );
                                                                    },
                                                                    onError: (
                                                                        e: any
                                                                    ) =>
                                                                        showError(
                                                                            e
                                                                                ?.response
                                                                                ?.data
                                                                                ?.message ||
                                                                                e?.message ||
                                                                                "Ошибка"
                                                                        ),
                                                                }
                                                            )
                                                        }
                                                        className="px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                                                    >
                                                        Подтвердить
                                                    </button>
                                                    <div className="flex gap-2">
                                                        <input
                                                            type="text"
                                                            value={cancelReason}
                                                            onChange={(e) =>
                                                                setCancelReason(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            placeholder="Причина отмены"
                                                            className="flex-1 px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none"
                                                        />
                                                        <button
                                                            onClick={() =>
                                                                adminCancelRussia.mutate(
                                                                    {
                                                                        id: p.id,
                                                                        reason: cancelReason,
                                                                    },
                                                                    {
                                                                        onSuccess:
                                                                            (
                                                                                res: any
                                                                            ) => {
                                                                                showSuccess(
                                                                                    res?.message ||
                                                                                        "Отменено"
                                                                                );
                                                                                setCancelReason(
                                                                                    ""
                                                                                );
                                                                            },
                                                                        onError:
                                                                            (
                                                                                e: any
                                                                            ) =>
                                                                                showError(
                                                                                    e
                                                                                        ?.response
                                                                                        ?.data
                                                                                        ?.message ||
                                                                                        e?.message ||
                                                                                        "Ошибка"
                                                                                ),
                                                                    }
                                                                )
                                                            }
                                                            className="px-3 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                                                        >
                                                            Отменить
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Модальное окно подтверждения карточного платежа */}

            {/* Компонент уведомлений */}
            <Notification
                message={notification.message}
                type={notification.type}
                isVisible={notification.isVisible}
                onClose={hideNotification}
            />
        </>
    );
};

export default AdminTopUpPage;
